import ResumeJobMatchConfig from './ResumeJobMatchConfig.js';

const matchConfigs = [
    ResumeJobMatchConfig
];

export default matchConfigs;
